import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "./Reveal";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items]);

  if (!items.length) return null;
  const cur = items[idx];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-heirloom-cream py-24 md:py-28">
      <div className="max-w-[900px] mx-auto px-6 text-center">
        <Reveal>
          <span className="gold-rule overline text-heirloom-maroon">Kind Words</span>
          <h2 className="font-display text-4xl md:text-5xl text-heirloom-obsidian mt-4">What Our Clients Say</h2>
        </Reveal>

        <div className="relative mt-12 bg-heirloom-bone rounded-3xl border border-heirloom-line shadow-[0_25px_60px_-35px_rgba(0,0,0,0.35)] p-10 md:p-14 min-h-[300px] flex flex-col items-center justify-center">
          <span className="absolute top-6 left-8 text-heirloom-maroon/15"><Quote size={64} /></span>
          <div className="flex gap-1 mb-6">
            {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-heirloom-gold text-heirloom-gold" />)}
          </div>
          <AnimatePresence mode="wait">
            <motion.div key={cur.id} data-testid="testimonial-quote" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }}>
              <p className="font-display text-xl md:text-2xl italic text-heirloom-obsidian leading-relaxed">{cur.quote}</p>
              <div className="mt-8">
                <div className="font-semibold text-heirloom-maroon">{cur.name}</div>
                <div className="overline text-[0.6rem] text-heirloom-obsidian/50 mt-1">{cur.event}</div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {items.map((_, i) => (
            <button key={i} data-testid={`testimonial-dot-${i}`} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all duration-400 ${i === idx ? "w-8 bg-heirloom-maroon" : "w-2 bg-heirloom-obsidian/20"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
